import { render, staticRenderFns } from "./invoices.vue?vue&type=template&id=d79578b6&scoped=true&"
import script from "./invoices.ts?vue&type=script&lang=ts&"
export * from "./invoices.ts?vue&type=script&lang=ts&"
import style0 from "./invoices.scss?vue&type=style&index=0&id=d79578b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d79578b6",
  null
  
)

export default component.exports